<pr-input-abstract [control]="control" [label]="label" [derrors]="derrors">
  <mat-select
    [value]="currentValue"
    (valueChange)="onInputChange($event)"
    [placeholder]="placeholder"
  >
    @for (item of options; track item) {
      <mat-option [value]="item.id">
        <div #customTemplate>
          <ng-content select="[option]"></ng-content>
        </div>
        @if (!customTemplate.children.length) {
          <ng-container
            [ngTemplateOutlet]="defaultValue"
            [ngTemplateOutletContext]="{ $implicit: item }"
          ></ng-container>
        }
      </mat-option>
    }
  </mat-select>
</pr-input-abstract>

<ng-template #defaultValue let-item>{{ item.value }}</ng-template>
